<template>
    <div>
        <!-- <h1 class="mdn-Heading mdn-Heading--sm">Parâmetros da Ordem de Serviço</h1> -->
        
        <SGPTabsMenuHorizontalComponent 
            :itemsTabs="itemsTabs"                        
        />        
        
    </div>
</template>

<script>
export default {  
    name: 'TarefasAssociaoesPage',    
    computed: {
        itemsTabs () {
            return [
                {
                    key: 'Tarefas',
                    label: 'Tarefas',
                    nameComponent:  'Tarefas',
                    pathComponent: 'modules/workflow/ctrl-tarefas/pages/TarefaPage'
                },
                {
                    key: 'Mobilidades',
                    label: 'Mobilidades',
                    nameComponent:  'Mobilidades',
                    pathComponent: 'modules/workflow/tarefas-mobilidades/pages/TarefaMobilidadePage'
                },                
            ]
        },

        itemsVertical () {
            return [
            
            ]
        }
    }
}


</script>

